import  React from 'react';
import { isPropertyEmpty } from '../../helpers/helpers';

function ModalPopUpComponent(props) {
    const defaultMessage = 'Det ser ut som om du ikke har delt din nåværende posisjon. For å kunne bruke denne funksjonen, må vi ha tilgang til din posisjon.Siden vil laste på nytt';
    const defaultTitle = 'Posisjon ikke delt'; 
    
    return (
        <div id="modal" className="d-flex align-item-center justify-content-center">
            <div className="d-flex align-item-center justify-content-between flex-direction-colomn">
                <div className="error-box" role="alert">
                    <div className="d-flex align-item-center gap-2 mb-10">
                        <div className="info-icon d-flex align-item-center justify-content-center">
                            <i className="fa fa-info"></i>
                        </div>
                        <strong className="ml-3">{isPropertyEmpty(props?.title) ? defaultTitle : props?.title}</strong>
                    </div>
                    <p className="text-center">  {isPropertyEmpty(props?.message) ? defaultMessage : props?.message} </p> </div>
            </div>
        </div>
    );
}

export { ModalPopUpComponent };